export interface IconProps {
  active: boolean;
  className?: string;
  disabled?: boolean;
}

export const circleColor = (active: boolean): string =>
  active ? '#d8e0ff' : '#000f35';
export const strokeColor = (active: boolean): string =>
  active ? '#000f35' : '#d8e0ff';
